/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Ssn/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Hide from './Hide/index'
import React from 'react'
import Show from './Show/index'



/** @type {import('Simple/types.js').View} */
export default function Ssn({
  children,
  viewPath = "/DesignSystem/DataVaxiomPatientInsuranceAssignForm/Content/PolicyHolder/Options/AddRelationship/Content/Details/Ssn"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Show'
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'Show'}>
<Show
  viewPath={`${viewPath}/Show`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Hide'}>
<Hide
  viewPath={`${viewPath}/Hide`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}